import * as yup from "yup";


export function createYupSchema(schema, config) {


  const { id , validations = {} } = config;
  let validationType = "string"
  if(validations != null){
  validationType = JSON.parse(validations).validationType;
  // validationType = validations.validationType;
  }
  if (!yup[validationType]) {
    return schema;
  }
  let validator = yup[validationType]();
  let localeValidations = [];
  if(validations != null){
  localeValidations =  JSON.parse(validations)["en"];
  // localeValidations =  validations[locale];
  }
 localeValidations.forEach((validation) => {
    const { params, type } = validation;
    let modifiedParams = [...params]
    modifiedParams[0] = type === "matches" ?  new RegExp(params[0]) : params[0]
    if (!validator[type]) {
      return;
    }
    // console.log(type, params);
    validator = validator[type](...modifiedParams);
  });
  schema[id] = validator;
  return schema;
}


